import React, { useState, useEffect } from "react";
import { Card, Col, Row, Button, Modal, Tab, Tabs } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import DataTable from "react-data-table-component";
import { particularPost, deleteComment } from "../../../common/api";
import { ShowToast } from "../../../common/function";
import avatar1 from "../../../assets/img/default.jpg";
import ConfigApp from "../../../common/config";
import { Sentry, Spinner } from "react-activity";

export default function Viewpost() {
  const location = useLocation();
  const navigate = useNavigate();
  const [postId, setPostId] = useState(null);
  const [postData, setPostData] = useState({});
  const [searchText, setSearchText] = useState("");
  const [show, setShow] = useState(false);
  const [postIds, setPostIds] = useState("");
  const [loading, setLoading] = useState(false);
  const [fullscreenMedia, setFullscreenMedia] = useState(null); // store selected image/video
  const [showModal, setShowModal] = useState(false);
  const [key, setKey] = useState("comments");
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setShow(false);
    setPostIds("");
  };

  const handleShow = (id) => {
    setShow(true);
    setPostIds(id);
  };

  // Store or retrieve postId
  useEffect(() => {
    const statePostId = location?.state?.postId;
    if (statePostId) {
      setPostId(statePostId);
      localStorage.setItem("view_post_id", statePostId);
    } else {
      const storedId = localStorage.getItem("view_post_id");
      if (storedId) {
        setPostId(storedId);
      } else {
        ShowToast(0, "Post ID not found. Redirecting...");
        navigate("/posts");
      }
    }
  }, []);

  useEffect(() => {
    if (postId) getParticularPost();
  }, [postId]);

  const getParticularPost = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    const response = await particularPost(token, { postId });
    if (response.success === true) {
      setLoading(false);
      setPostData(response.body);
    } else {
      ShowToast(0, response.message || "Post fetch failed");
    }
  };

  const handleDeleteComment = async (id) => {
    const token = localStorage.getItem("token");
    setIsLoading(true)
    const response = await deleteComment(token, { commentId: id });
    setIsLoading(false)
    if (response.success) {
      ShowToast(1, "Comment deleted successfully");
      getParticularPost();
      handleClose();
    }
  };
  const openFullscreen = (mediaUrl, isVideo) => {
    setFullscreenMedia({ url: mediaUrl, isVideo });
    setShowModal(true);
  };

  const getRelativeTime = (date) => {
    const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });
    const now = new Date();
    const created = new Date(date);
    const diffInSeconds = Math.floor((now - created) / 1000);
    const ranges = {
      year: 3600 * 24 * 365,
      month: 3600 * 24 * 30,
      week: 3600 * 24 * 7,
      day: 3600 * 24,
      hour: 3600,
      minute: 60,
      second: 1,
    };
    for (let key in ranges) {
      const delta = Math.floor(diffInSeconds / ranges[key]);
      if (isFinite(delta) && Math.abs(delta) > 0) {
        return rtf.format(-delta, key);
      }
    }
    return "just now";
  };

  const commentData =
    postData?.comments?.map((item, index) => ({
      id: index + 1,
      commentId: item._id,
      name: item.userDetails?.full_name || "Anonymous",
      imgurl: item.userDetails?.profile_url,
      comment: item.comment,
      timeOriginal: item.createdAt, // <-- Add this
      time: getRelativeTime(item.createdAt),
      repliesCount: item.repliesCount,
    })) || [];

  const filteredData = commentData.filter(
    (item) =>
      JSON.stringify(item).toLowerCase().indexOf(searchText.toLowerCase()) !==
      -1
  );

  const columns = [
    {
      name: "Sr. No.",
      width: "100px",
      selector: (row, index) => index + 1,
      sortable: true,
    },
    {
      name: "Name",
      minWidth: "220px",
      selector: (row) => row.name,
      cell: (row) => (
        <>
          <img
            className="table_img rounded-circle img-thumbnail me-2"
            src={
              row.imgurl.startsWith("http")
                ? row.imgurl
                : row.imgurl
                ? `${ConfigApp.IMAGE_URL}${row.imgurl}`
                : avatar1
            }
            alt=""
            width={35}
            height={35}
          />
          {row.name ? row.name : "N/A"}
        </>
      ),
    },
    {
      name: "Comment",
      minWidth: "300px",
      cell: (row) => (
        <div
          style={{
            maxHeight: "100px",
            overflowY: "auto",
            whiteSpace: "pre-wrap",
            paddingRight: "8px",
          }}
        >
          {row.comment || "N/A"}
        </div>
      ),
      wrap: true, // Optional: adds padding and allows wrapping
    },

    {
      name: "Time",
      minWidth: "180px",
      selector: (row) => row.time,
      cell: (row) => {
        const date = new Date(row.timeOriginal);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12; // Convert to 12-hour format

        const formatted = `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
        return <>{formatted}</>;
      },
    },
    {
      name: "Count",
      center: true,
      cell: (row) => (
        <Link
          to="/posts/view-post/all-comments"
          state={{ commentId: row.commentId }}
        >
          {row.repliesCount || "0"}
        </Link>
      ),
      wrap: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <Link className="btndelete" onClick={() => handleShow(row._id)}>
          <Icon icon="tabler:trash" />
        </Link>
      ),
    },
  ];

  return (
    <React.Fragment>
      {loading ? (
        <Sentry
          color="#2B5AAC"
          size={30}
          speed={1}
          animating={true}
          style={{ marginLeft: "45%", marginTop: "300px" }}
        />
      ) : (
        <>
          <Card className="mb-3">
            <Card.Header className="d-flex align-items-center justify-content-between flex-wrap">
              <h5>Post Details</h5>
              <Link
                className="btn btn-primary2 d-inline-flex align-items-center justify-content-center px-4 min_width140"
                to={location?.state?.status === "view" ? "/users" : "/posts"}
              >
                Back
              </Link>
            </Card.Header>

            <Card.Body className="mt-3">
              <div className="taledtl_div">
                <Row>
                  <Col md="6">
                    <div className="talefile_list">
                      <div className="tablefilelist_grid">
                        <h4>About Post</h4>
                        <p>{postData?.about_post || "-"}</p>
                      </div>
                      <div className="tablefilelist_grid">
                        <h4>Author</h4>
                        <p>{postData?.userDetails?.full_name || "-"}</p>
                      </div>
                      <div className="tablefilelist_grid">
                        <h4>Likes</h4>
                        <p className="mt-2">
                          <span className="Active badge">
                            {postData?.likesCount || 0}
                          </span>
                        </p>
                      </div>
                      <div className="tablefilelist_grid">
                        <h4>Status</h4>
                        <p className="mt-2">
                          <span className="Active badge">Published</span>
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="talefile_list">
                      <div className="tablefilelist_grid">
                        <h4>Comments</h4>
                        <p className="mt-2">
                          <span className="Active badge">
                            {postData?.commentsCount || 0}
                          </span>
                        </p>
                      </div>
                      <div className="tablefilelist_grid">
                        <h4>Published On</h4>
                        <p>
                          {postData?.createdAt
                            ? (() => {
                                const date = new Date(postData.createdAt);
                                const day = String(date.getDate()).padStart(
                                  2,
                                  "0"
                                );
                                const month = String(
                                  date.getMonth() + 1
                                ).padStart(2, "0");
                                const year = date.getFullYear();
                                let hours = date.getHours();
                                const minutes = String(
                                  date.getMinutes()
                                ).padStart(2, "0");
                                const ampm = hours >= 12 ? "PM" : "AM";
                                hours = hours % 12;
                                hours = hours ? hours : 12; // the hour '0' should be '12'
                                return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
                              })()
                            : "-"}
                        </p>
                      </div>
                    </div>
                  </Col>
                  {/* <Col md="12">
                    <div className="talefile_list">
                      <div className="tablefilelist_grid">
                        <h4>Description</h4>
                        <p className="mt-2">{postData?.about_post || "-"}</p>
                      </div>
                    </div>
                  </Col> */}

                  {postData?.media_url?.length > 0 && (
                    <Col md="12" className="mt-4">
                      <div className="tablefilelist_grid">
                        <h4>Media</h4>
                        <Row>
                          {postData.media_url.map((url, index) => (
                            <Col
                              key={index}
                              md={2}
                              sm={4}
                              xs={6}
                              className="mb-3"
                              onClick={() =>
                                openFullscreen(
                                  ConfigApp.URL + url,
                                  url.includes(".mp4")
                                )
                              }
                              style={{ cursor: "pointer" }}
                            >
                              {url.includes(".mp4") ? (
                                <video
                                  src={ConfigApp.URL + url}
                                  className="img-fluid rounded border"
                                  style={{
                                    objectFit: "cover",
                                    maxHeight: "180px",
                                  }}
                                  muted
                                />
                              ) : (
                                <img
                                  src={ConfigApp.URL + url}
                                  alt={`media-${index}`}
                                  className="img-fluid rounded border"
                                  style={{
                                    objectFit: "cover",
                                    height: "180px",
                                    width: "100%",
                                  }}
                                />
                              )}
                            </Col>
                          ))}
                        </Row>
                      </div>
                    </Col>
                  )}
                </Row>
              </div>
            </Card.Body>
          </Card>
          <Tabs
            defaultActiveKey="comments"
            className="customtabs mb-2"
            activeKey={key}
            onSelect={(k) => setKey(k)}
          >
            <Tab eventKey="comments" title="Comments">
              <Card>
                <Card.Header className="py-4">
                  <h5>Comments</h5>
                </Card.Header>
                <Card.Body>
                  <div className="text-end mb-3">
                    <input
                      type="text"
                      placeholder="Search..."
                      className="searchfield"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                    />
                  </div>
                  <DataTable
                    columns={columns}
                    data={filteredData}
                    pagination
                    responsive
                    className="custom-table"
                  />
                </Card.Body>
              </Card>
            </Tab>
            <Tab eventKey="likes" title="Likes">
              <Row>
                {postData &&
                postData?.likesWithUserDetails &&
                postData?.likesWithUserDetails?.length > 0 ? (
                  postData?.likesWithUserDetails?.map((item, index) => (
                    <Col key={index} md={4} className="mb-4">
                      <div className="stats">
                        <img
                          className="table_img rounded-circle img-thumbnail"
                          src={
                            item?.userDetails?.profile_url?.startsWith("http")
                              ? item?.userDetails?.profile_url
                              : item?.userDetails?.profile_url
                              ? `${ConfigApp.IMAGE_URL}${item?.userDetails?.profile_url}`
                              : avatar1
                          }
                          alt=""
                          style={{ width: "70px", height: "70px" }}
                        />
                        <div className="stats-cont">
                          <h4 className="mb-0">
                            {item?.userDetails?.full_name}
                          </h4>
                          <h4 className="mb-0">{item?.userDetails?.email}</h4>
                        </div>
                      </div>
                    </Col>
                  ))
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center", // Horizontal center
                      alignItems: "center", // Vertical center
                    }}
                  >
                    <p>No likes found.</p>
                  </div>
                )}
              </Row>
            </Tab>
          </Tabs>

          <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            size="lg"
            centered
            dialogClassName="custom-fullscreen-modal"
          >
            <Modal.Body className=" bg-black position-relative d-flex justify-content-center align-items-center">
              {/* Close Button */}
              <button
                onClick={() => setShowModal(false)}
                style={{
                  position: "absolute",
                  top: 20,
                  right: 20,
                  zIndex: 10,
                  background: "rgba(0,0,0,0.5)",
                  border: "none",
                  borderRadius: "50%",
                  width: 40,
                  height: 40,
                  color: "#fff",
                  fontSize: 24,
                  lineHeight: "40px",
                  textAlign: "center",
                  cursor: "pointer",
                }}
              >
                &times;
              </button>

              {fullscreenMedia?.isVideo ? (
                <video
                  src={fullscreenMedia.url}
                  controls
                  autoPlay
                  style={{
                    // maxWidth: "59%",
                    maxHeight: "95vh",
                    borderRadius: 10,
                  }}
                />
              ) : (
                <img
                  src={fullscreenMedia?.url}
                  alt="fullscreen-media"
                  className="fullscreen-image"
                  style={{
                    width: "100%",
                    borderRadius: 10,
                    height: "400px",
                    objectFit: "contain",
                  }}
                />
              )}
            </Modal.Body>
          </Modal>
        </>
      )}

      {/* Delete Modal */}
      <Modal className="modal_Delete" show={show} onHide={handleClose} centered>
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="delete_icon" icon="gg:close-o"></Icon>
            <h3>Are You Sure ?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <Button
            variant="outline-danger"
            onClick={handleClose}
            className="px-4 me-3"
          >
            Cancel
          </Button>
          <Button
            variant="success"
            className="px-4 min_width110"
            onClick={() => handleDeleteComment(postIds)}
          >
            {isLoading ? (
              <Spinner animation="border" variant="primary" size={15} />
            ) : (
              "Ok"
            )}
          </Button>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
